import { useCallback } from 'react';
import { useEditorStore } from '~/shell/Store';
import { usePreviewTranslationStore } from '~/shell/PreviewTranslationStore';

export const usePreview = () => {
  const { apiService, training, sequence } = useEditorStore();
  const { previewTranslationLocale } = usePreviewTranslationStore();

  const replaceDomainIfNeeded = useCallback((url: string): string => {
    const isDevSite = window.location.hostname === 'app.easyllama.dev';

    if (isDevSite) {
      return url.replace(/\.com/g, '.dev');
    }

    return url;
  }, []);

  const openPreview = useCallback(
    async (options?: { queryParams?: Record<string, string> }) => {
      if (apiService && training && sequence) {
        const preview = await apiService.getPreviewUrl(
          training.id as number,
          sequence.id,
          { previewTranslationLocale }
        );

        if (preview && preview.previewUrl) {
          const modifiedUrl = replaceDomainIfNeeded(preview.previewUrl);
          const url = new URL(modifiedUrl);

          if (options?.queryParams) {
            Object.entries(options.queryParams).forEach(([key, value]) => {
              url.searchParams.set(key, value);
            });
          }

          const newUrl = url.toString() + '&hideHomeIcon=true';

          const newWindow = window.open(newUrl, '_blank');

          if (newWindow) {
            setTimeout(() => {
              try {
                newWindow.document.title = 'Course Preview - EasyLlama';
              } catch (error) {
                console.log(
                  'Cannot change window title due to CORS restrictions'
                );
              }
            }, 1000);
          }
        }
      }
    },
    [
      apiService,
      training,
      sequence,
      replaceDomainIfNeeded,
      previewTranslationLocale
    ]
  );

  return { openPreview };
};
